module.exports = __webpack_public_path__ + "img/Picture44.39c308ea.png";